import { FormFieldOption } from "../../../../__generated__/api";

export function flattenOptions(options: FormFieldOption[], spaces: string): string {
    return options.map(row => {
        const children = row.children?.isNotEmpty ? `\n${flattenOptions(row.children, `${spaces}-`)}` : "";

        const line = `${spaces}${row.label}${row.description ? ` - ${row.description}` : ""}`.trim();
        return `${line}${children}`.trim();
    }).join("\n");
}

export function optionsFromString(lines: string[]): FormFieldOption[] {
    const options: FormFieldOption[] = [];
    let last: FormFieldOption | undefined;
    let buffer: string[] = [];
    lines.forEach(line => {
        if (line.trim() === "") {
            return;
        }
        if (line.startsWith("-")) {
            buffer.push(line.substring(1));
        } else {
            if (last) {
                last.children = buffer.isNotEmpty ? optionsFromString(buffer).limit(100) : undefined;
            }
            buffer = [];
            last = {
                label: line.trim(),
                value: line.trim(),
                description: "",
            };
            options.push(last);
        }
    });
    if (last) {
        last.children = buffer.isNotEmpty ? optionsFromString(buffer).limit(100) : undefined;
    }
    return options;
}
